
jQuery(function($){

    $(document).on('wpcf7mailsent', function(e) {

        const apiResp = e.originalEvent?.detail?.apiResponse || null;

        const n8n = apiResp?.n8n || null;

        if (!n8n) return;

        //const $box = $('#n8n-result');
        //if (!$box.length) return;

        let text = '';

        if (typeof n8n.message === 'string') {
            text = n8n.message;
        } else if (typeof n8n.raw === 'string') {
            text = n8n.raw;
        } else {
            text = JSON.stringify(n8n);
        }

        //$box.text(text);
    });
    
    const $invoiceInput = $('input[name="form-invoice-number"]');

    if ($invoiceInput.length) {
        $invoiceInput.on('change', function() {
            const $this = $(this);
            const invoiceNo = $this.val();
            const $container = $this.parent();

            // Limpiar mensaje previo si existe
            $('#invoice-status').remove();

            if (invoiceNo.length < 3) return;

            // Form Data para enviar a WP
            const formData = new FormData();
            formData.append('action', 'check_bc_invoice');
            formData.append('form-invoice-number', invoiceNo);

            // Fetch a la URL de AJAX de WordPress
            fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(res => {
                const $statusMsg = $('<span>', {
                    id: 'invoice-status',
                    class: 'wpcf7-not-valid-tip'
                });

                if (res.data.exists) {
                    $statusMsg.text(window.translations.cf7_valid_invoice)
                        .addClass('wpcf7-is-valid-tip');
                } else {
                    $statusMsg.text(window.translations.cf7_invalid_invoice);
                }

                $container.append($statusMsg);
            })
            .catch(error => console.error('Error:', error));
        });
    }

});